$(document).ready(function () {
  	$('.block-slider .owl-carousel').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        dots: false,
        responsive:{
            0:{
                items:1
            }
        }
    });
    $('.slider-level .owl-carousel').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        dots: true,
        responsive:{
            0:{
                items:1
            }
        }
    });
    $('.slider-brand .owl-carousel').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        dots: true,
        responsive:{
            0:{
                items:1
            },
            480: {
                items: 2
            },
            680:{
                items: 3
            },
            837: {
                items: 4
            },
            1000: {
                items: 5
            }
        }
    });
});
